export default __webpack_public_path__ + "static/media/check-mark-circle.71b7db84.svg";